<template>
  <v-tooltip bottom color="00BD73" max-width="320">
    <template v-slot:activator="{ on, attrs }">
      <span
        class="payment-unavailable-status"
        :class="{ 'payment-unavailable-status--legend': legend }"
        v-bind="attrs"
        v-on="on"
      >
        <template v-if="legend">
          <v-icon size="20" color="#e65100" class="mr-1">mdi-account-cancel</v-icon>
          <span class="payment-unavailable-label">{{ $t('dueDiligence.paymentAssignedToAnotherExporter') }}</span>
        </template>
        <v-btn
          v-else
          small
          rounded
          min-width="160"
          depressed
          class="payment-unavailable-button"
          height="34"
          tabindex="-1"
        >
          {{ $t('dueDiligence.paymentAssignedToAnotherExporter') }}
        </v-btn>
      </span>
    </template>
    <span>{{ $t('dueDiligence.paymentUnavailableTooltip') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'PaymentUnavailableStatus',
  props: {
    legend: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.payment-unavailable-status {
  display: inline-block;
  cursor: help;
  pointer-events: auto;
}

.payment-unavailable-status--legend {
  display: inline-flex;
  align-items: center;
}

/* .payment-unavailable-label {
  color: #e65100;
} */

.payment-unavailable-button {
  background-color: #fff3e0 !important;
  border: 2px solid #e65100 !important;
  color: #e65100 !important;
  pointer-events: none;
}
</style>
